import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyDajWsUXFIZcF-ucEleUe58sccHaVuEA-c",
  authDomain: "md-sabeel.firebaseapp.com",
  projectId: "md-sabeel",
  storageBucket: "md-sabeel.appspot.com",
  messagingSenderId: "36233746413",
  appId: "1:36233746413:web:a0e9b9d3c48c2e54ce79e4",
  measurementId: "G-RFL333FKGL",
};


const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();

export default db;